import React, { useState, useEffect, useContext } from 'react'
import useIndexStyles from './index-style'
import { styled } from '@mui/material/styles'
import './index-style.css'
import Box from '@mui/material/Box'
import MuiAppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import { Menu } from '@material-ui/core'
import { Notifications as NotificationsIcon } from '@material-ui/icons'
import { Button, Alert, Fade, Paper } from '@mui/material'
import SideBar from './Components/sidebar'
import dayjs from 'dayjs'
import { ClearAllNotificationNew } from '../services/api'
import CustomAlert from '../components/CustomAlert/CustomAlert'
import axios from 'axios'
import WarningIcon from '@mui/icons-material/Warning'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { NotificationContext } from '../contexts/notificationContext'
import { useLocation, useNavigate } from 'react-router-dom'
import usePermission from '../hooks/usePermission'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import MobileBottomNav from './Components/MobileBottomNav'
// import { Slide } from '@mui/material'
// Removed mobile signout Slide
import LogoP1 from '../assets/images/DE_logo.png'
import { AuthContext } from '../routes/AuthContext'
import { removeUserType, removeToken } from '../redux/reducers/authReducer'
import { useDispatch } from 'react-redux'

const drawerWidth = 240
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

const MainLayout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState([])
  const [alertMessage, setalertMessage] = useState('')
  const [alertOpen, setAlertOpen] = useState(false)
  const [selectedNotificationId, setSelectedNotificationId] = useState(null)
  const [showAlert, setShowAlert] = useState(false)
  const [exportPopupOpen, setExportPopupOpen] = useState(false)
  const [exportPopupJob, setExportPopupJob] = useState(null)
  const navigate = useNavigate()
  const { state } = useLocation()
  console.log('Rendered', state)

  const { notifications: jobNotifications, updateJobNotification } =
    useContext(NotificationContext)

  const { setToken } = useContext(AuthContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { is, can } = usePermission()
  // Check if user has permission to view notifications
  const canViewNotifications = is('Super Admin') || is('Admin') || is('Asset Management') || can('notification.read') || can('notification.all')

  const handleNotificationView = () => {
    navigate('/NotificationView')
  }

  // useEffect(() => {
  //   if (canViewNotifications) {
  //     const fetchNotifications = async () => {
  //       try {
  //         const baseUrl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING?.replace(/\/$/, '') + '/api'
  //         const response = await axios.get(
  //           `${baseUrl}/notifications/high-severity`
  //         )
  //         const notifications = response.data.notifications

  //         setMessage(notifications)

  //         const hasHighSeverity = notifications.some(
  //           (n) => n.severity === 'high' && n.status === 'unread'
  //         )
  //         if (hasHighSeverity) {
  //           setShowAlert(true)
  //           const timer = setTimeout(() => setShowAlert(false), 6000)
  //           return () => clearTimeout(timer)
  //         }
  //       } catch (error) {
  //         console.log('Error fetching notifications:', error)
  //       }
  //     }

  //     fetchNotifications()
  //     const interval = setInterval(fetchNotifications, 900000)
  //     return () => clearInterval(interval)
  //   }
  // }, [canViewNotifications])

  useEffect(() => {
    // Updated pollJobStatus function with Authorization header
    const pollJobStatus = async (job) => {
      try {
        // Get token from localStorage or state
        const token = localStorage.getItem('accessToken')
        console.log('Polling job status for job:', token);


        const response = await axios.get(job.checkEndpoint, {
          headers: { Authorization: `Bearer ${token}` },
        })

        const jobData = response.data?.data ?? response.data
        const { status, progress, downloadUrl, downloadUrls, error } = jobData

        if (status === 'completed') {
          const finalUrl = downloadUrl || (downloadUrls?.[0]?.url ?? null)
          updateJobNotification(job.id, {
            status: 'completed',
            progress: 100,
            message: 'Export completed successfully',
            severity: 'success',
            downloadUrl: finalUrl,
          })

          setExportPopupJob({
            ...job,
            downloadUrl: finalUrl,
            message: `Export completed: ${job.title}`,
            severity: 'success',
          })

          setExportPopupOpen(true)
          setTimeout(() => setExportPopupOpen(false), 15000)
        } else if (status === 'failed') {
          updateJobNotification(job.id, {
            status: 'failed',
            message: error || 'Export failed',
            severity: 'error',
          })
          setExportPopupJob({
            ...job,
            message: `Export failed: ${job.title}`,
            severity: 'error',
          })
          setExportPopupOpen(true)
          setTimeout(() => setExportPopupOpen(false), 15000)
        } else {
          updateJobNotification(job.id, {
            status,
            progress,
            message: `Export in progress: ${progress}%`,
          })
        }
      } catch (error) {
        console.error('Error polling job status:', error)
        updateJobNotification(job.id, {
          status: 'failed',
          message: 'Error checking job status',
          severity: 'error',
        })
        setExportPopupJob({
          ...job,
          message: `Export failed: ${job.title}`,
          severity: 'error',
        })
        setExportPopupOpen(true)
        setTimeout(() => setExportPopupOpen(false), 15000)
      }
    }

    const intervals = jobNotifications
      .filter(
        (notif) =>
          notif.type === 'DATA_EXPORT' &&
          ['pending', 'processing'].includes(notif.status)
      )
      .map((job) => {
        const interval = setInterval(() => pollJobStatus(job), 5000)
        return { jobId: job.id, interval }
      })

    return () => intervals.forEach(({ interval }) => clearInterval(interval))
  }, [jobNotifications, updateJobNotification])

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown time'
    try {
      return dayjs(dateString).format('MMM DD, YYYY | h:mm A')
    } catch (error) {
      return 'Invalid date'
    }
  }

  const toggleNotificationDetail = (notificationId) => {
    setSelectedNotificationId(
      selectedNotificationId === notificationId ? null : notificationId
    )
  }

  const clearNotifications = () => {
    const token = localStorage.getItem('accessToken')
    const userId = localStorage.getItem('userId')
    ClearAllNotificationNew(token, userId).then((resp) => {
      if (resp?.data?.success) {
        setMessage([])
        setalertMessage(resp?.data?.message)
        setAlertOpen(true)
        setSelectedNotificationId(null)
      }
    })
  }

  const alertClose = (event, reason) => {
    if (reason === 'clickaway') return
    setAlertOpen(false)
  }

  const handleDrawerOpen = () => setOpen(true)
  const handleDrawerClose = () => setOpen(false)

  const handleLogout = () => {
    localStorage.removeItem('accessToken')
    const storedRememberMe = localStorage.getItem('rememberMeChecked')
    if (storedRememberMe === 'false') {
      localStorage.removeItem('encryptedUsername')
      localStorage.removeItem('encryptedPassword')
    }

    setToken(null)
    dispatch(removeUserType())
    dispatch(removeToken())
    navigate('/', { state: { logoutSuccess: true } })
  }

  const classes = useIndexStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const openNotification = Boolean(anchorEl)

  // Fixed: Handle notification click properly
  const handleClick = (event) => {
    // Prevent event propagation to stop notification menu from closing immediately
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setSelectedNotificationId(null)
  }

  const handleExportPopupClose = () => {
    setExportPopupOpen(false)
  }

  const handleDownload = () => {
    if (exportPopupJob && exportPopupJob.downloadUrl) {
      window.open(exportPopupJob.downloadUrl, '_blank')
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const currentDate = new Date()
      const date = currentDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      const time = currentDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      setDateTime(`${dayjs(date).format('DD-MM-YYYY')}, ${time}`)
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  const getNotificationColor = (notification) => {
    if (notification.type === 'DATA_EXPORT') {
      switch (notification.status) {
        case 'processing':
          return '#1976d2' // blue
        case 'completed':
          return '#4caf50' // green
        case 'failed':
          return '#f44336' // red
        default:
          return '#757575' // gray
      }
    } else {
      switch (notification.severity) {
        case 'high':
        case 'error':
          return '#f44336' // red
        case 'medium':
          return '#ff9800' // orange
        case 'low':
        case 'success':
          return '#4caf50' // green
        default:
          return '#757575' // gray
      }
    }
  }

  const getTimeAgo = (dateString) => {
    if (!dateString) return ''
    const now = dayjs()
    const date = dayjs(dateString)
    const diffMinutes = now.diff(date, 'minute')
    if (diffMinutes < 1) return 'just now'
    if (diffMinutes < 60) return `${diffMinutes} min ago`
    const diffHours = now.diff(date, 'hour')
    if (diffHours < 24) return `${diffHours} hr ago`
    const diffDays = now.diff(date, 'day')
    if (diffDays < 30) return `${diffDays} day ago`
    return date.format('MMM DD')
  }

  const [dateTime, setDateTime] = useState('')

  const allNotifications = [...message, ...jobNotifications].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  )

  return (
    <Box sx={{ display: 'flex' }}>
      <CustomAlert
        handleClose={alertClose}
        open={alertOpen}
        message={alertMessage}
      />
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{
          backgroundColor: '#F9FAFD !important',
          ...(isMobile && { width: '100%', marginLeft: 0 })
        }}
        elevation={0}
      >
        <Toolbar
          sx={{
            backgroundColor: '#F9FAFD !important',
            display: 'flex',
            justifyContent: isMobile ? 'space-between' : 'flex-end',
            alignItems: 'center',
            px: isMobile ? 1 : 3
          }}
        >
          {isMobile && (
            <IconButton sx={{ p: 0 }}>
              <img src={LogoP1} alt="Logo" style={{ height: 24, objectFit: 'contain' }} />
            </IconButton>
          )}
          <Typography
            sx={{
              color: '#949494',
              fontFamily: 'Roboto',
              fontSize: 18,
              marginLeft: 2,
            }}
            noWrap
            component="div"
          >
            {dateTime}
          </Typography>
          {canViewNotifications && (
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 5, position: 'relative' }}
              aria-controls={openNotification ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openNotification ? 'true' : undefined}
            >
              <NotificationsIcon className="noti_i" />
              {(message.filter((n) => n.status === 'unread').length > 0 ||
                jobNotifications.length > 0) && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      width: 10,
                      height: 10,
                      backgroundColor: 'red',
                      borderRadius: '50%',
                    }}
                  />
                )}
              {showAlert && message && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: -10,
                    right: -10,
                    width: 300,
                    zIndex: 9999,
                    animation: 'fadeIn 0.3s ease-in-out',
                  }}
                >
                  <Alert
                    severity="error"
                    icon={<WarningIcon fontSize="inherit" />}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation() // Prevent propagation
                          setShowAlert(false)
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{
                      boxShadow: 3,
                      borderRadius: 2,
                      alignItems: 'flex-start',
                      '& .MuiAlert-message': { padding: '8px 0' },
                    }}
                  >
                    {message
                      .filter(
                        (n) => n.severity === 'high' && n.status === 'unread'
                      )
                      .slice(0, 3)
                      .map((notification, index) => (
                        <Box
                          key={index}
                          sx={{
                            width: '100%',
                            mb: index < 2 ? 1 : 0,
                            pb: index < 2 ? 1 : 0,
                            borderBottom:
                              index < 2 ? '1px solid rgba(0,0,0,0.1)' : 'none',
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 'bold' }}
                          >
                            {notification.plantName}
                          </Typography>
                          <Typography variant="body2">
                            {notification.message}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: 'text.secondary',
                              display: 'block',
                              mt: 0.5,
                            }}
                          >
                            {formatDate(notification.created_at)}
                          </Typography>
                        </Box>
                      ))}
                  </Alert>
                </Box>
              )}
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      {!isMobile && (
        <SideBar
          open={open}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
        />
      )}
      <Box
        component="main"
        className={classes.bgColor}
        sx={{
          flexGrow: 1,
          p: isMobile ? 1 : 3,
          mt: 5,
          pb: isMobile ? '80px !important' : '20px !important',
          ...(isMobile && {
            height: 'calc(100vh - 56px) !important',
            marginTop: '56px !important',
            px: 0
          })
        }}
      >
        {canViewNotifications && (
          <Menu
            anchorEl={anchorEl}
            open={openNotification}
            onClose={handleClose}
            onClick={(e) => e.stopPropagation()} // Fixed: Prevent menu closing on clicks inside
            PaperProps={{
              elevation: 8,
              sx: {
                overflow: 'visible',
                mt: 1.5,
                width: 360,
                maxHeight: 500,
                overflowY: 'auto',
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <div className="noti_h_txt">
              Notifications
              <Typography variant="caption" sx={{ ml: 1, color: '#757575' }}>
                (
                {
                  allNotifications.filter(
                    (n) =>
                      n.status === 'unread' ||
                      n.status === 'pending' ||
                      n.status === 'processing'
                  ).length
                }{' '}
                unread)
              </Typography>
            </div>
            <div className="NotificationComponent">
              <div className="customMenuList">
                {allNotifications.length === 0 ? (
                  <Box sx={{ p: 2, textAlign: 'center', color: '#757575' }}>
                    No notifications
                  </Box>
                ) : (
                  allNotifications.map((notification, index) => (
                    <React.Fragment
                      key={notification.id || notification.id || index}
                    >
                      <div
                        className={`noti_bg_4 ${notification.status === 'unread' ? 'noti_unread' : ''
                          }`}
                        onClick={(e) => {
                          e.stopPropagation() // Fixed: Prevent propagation
                          toggleNotificationDetail(
                            notification.id ||
                            notification.id ||
                            `notification-${index}`
                          )
                        }}
                        style={{
                          cursor: 'pointer',
                          borderLeft: `4px solid ${getNotificationColor(
                            notification
                          )}`,
                          padding: '12px',
                          margin: '8px 0',
                          backgroundColor:
                            notification.status === 'unread' ||
                              notification.status === 'pending' ||
                              notification.status === 'processing'
                              ? '#f5f5f5'
                              : 'transparent',
                          transition: 'all 0.3s ease-in-out',
                        }}
                      >
                        <div className="w100">
                          <div className="align_btw mb_8">
                            <div className="n_h">
                              {notification.plantName || notification.title}
                            </div>
                            <div className="n_dt">
                              {getTimeAgo(notification.created_at)}
                            </div>
                          </div>
                          <div
                            className="n_sd"
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: '320px',
                            }}
                          >
                            {notification.message}
                          </div>
                          {notification.type === 'DATA_EXPORT' &&
                            notification.status === 'processing' && (
                              <div style={{ marginTop: '8px' }}>
                                Progress: {notification.progress}%
                              </div>
                            )}
                          {notification.type === 'DATA_EXPORT' &&
                            notification.status === 'completed' && (
                              <a
                                href={notification.downloadUrl}
                                download
                                style={{
                                  marginTop: '8px',
                                  display: 'block',
                                  color: '#1976d2',
                                }}
                              >
                                Download File
                              </a>
                            )}
                          {notification.type === 'DATA_EXPORT' &&
                            notification.status === 'failed' && (
                              <div style={{ marginTop: '8px', color: 'red' }}>
                                {notification.message}
                              </div>
                            )}
                          <div
                            className="align_btw"
                            style={{ marginTop: '8px' }}
                          >
                            <div
                              className="n_sd"
                              style={{
                                textTransform: 'capitalize',
                                fontSize: '12px',
                                color: '#757575',
                              }}
                            >
                              {notification.type
                                ?.replace(/_/g, ' ')
                                .toLowerCase()}
                            </div>
                            <div
                              style={{
                                fontSize: '12px',
                                padding: '2px 8px',
                                borderRadius: '10px',
                                backgroundColor:
                                  getNotificationColor(notification),
                                color: 'white',
                              }}
                            >
                              {notification.severity || notification.status}
                            </div>
                          </div>
                        </div>
                      </div>
                      {selectedNotificationId ===
                        (notification.id ||
                          notification.id ||
                          `notification-${index}`) && (
                          <Box
                            sx={{
                              p: 2,
                              mb: 2,
                              backgroundColor: '#f9f9f9',
                              border: '1px solid #eee',
                              borderRadius: '4px',
                              mx: 1.5,
                            }}
                            onClick={(e) => e.stopPropagation()} // Fixed: Prevent propagation
                          >
                            <Button
                              startIcon={<ArrowBackIcon />}
                              onClick={(e) => {
                                e.stopPropagation() // Fixed: Prevent propagation
                                setSelectedNotificationId(null)
                              }}
                              sx={{ mb: 1.5, p: 0, color: '#757575' }}
                              size="small"
                            >
                              Back to list
                            </Button>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: 1.5,
                                pb: 1.5,
                                borderBottom: '1px solid #eee',
                              }}
                            >
                              <Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 'bold' }}
                                >
                                  {notification.plantName || notification.title}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: '#757575' }}
                                >
                                  {notification.type?.replace(/_/g, ' ')}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  fontSize: '12px',
                                  padding: '4px 12px',
                                  borderRadius: '16px',
                                  backgroundColor:
                                    getNotificationColor(notification),
                                  color: 'white',
                                }}
                              >
                                {notification.severity || notification.status}
                              </Box>
                            </Box>
                            <Box sx={{ my: 2 }}>
                              <Typography variant="body1">
                                {notification.message}
                              </Typography>
                            </Box>
                            <Box sx={{ mt: 2 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 'bold', mb: 1 }}
                              >
                                Details
                              </Typography>
                              <Box
                                sx={{
                                  display: 'grid',
                                  gridTemplateColumns: '1fr 1fr',
                                  gap: 2,
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: '#757575' }}
                                  >
                                    Created at
                                  </Typography>
                                  <Typography variant="body2">
                                    {formatDate(notification.created_at)}
                                  </Typography>
                                </Box>
                                {notification.type !== 'DATA_EXPORT' && (
                                  <>
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: '#757575' }}
                                      >
                                        Last escalated
                                      </Typography>
                                      <Typography variant="body2">
                                        {formatDate(notification.lastEscalated) ||
                                          'N/A'}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: '#757575' }}
                                      >
                                        Escalation level
                                      </Typography>
                                      <Typography variant="body2">
                                        {notification.escalationLevel || 'N/A'}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: '#757575' }}
                                      >
                                        Last data time
                                      </Typography>
                                      <Typography variant="body2">
                                        {formatDate(notification.lastDataTime) ||
                                          'N/A'}
                                      </Typography>
                                    </Box>
                                    {notification.resolved && (
                                      <Box sx={{ gridColumn: '1 / span 2' }}>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: '#757575' }}
                                        >
                                          Resolution details
                                        </Typography>
                                        <Typography variant="body2">
                                          {notification.resolutionDetails ||
                                            'No details provided'}
                                        </Typography>
                                      </Box>
                                    )}
                                  </>
                                )}
                                {notification.type === 'DATA_EXPORT' && (
                                  <>
                                    <Box>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: '#757575' }}
                                      >
                                        Status
                                      </Typography>
                                      <Typography variant="body2">
                                        {notification.status}
                                      </Typography>
                                    </Box>
                                    {notification.status === 'processing' && (
                                      <Box>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: '#757575' }}
                                        >
                                          Progress
                                        </Typography>
                                        <Typography variant="body2">
                                          {notification.progress}%
                                        </Typography>
                                      </Box>
                                    )}
                                    {notification.status === 'completed' && (
                                      <Box>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: '#757575' }}
                                        >
                                          Download
                                        </Typography>
                                        <a
                                          href={notification.downloadUrl}
                                          download
                                          onClick={(e) => e.stopPropagation()} // Fixed: Prevent propagation
                                        >
                                          Download File
                                        </a>
                                      </Box>
                                    )}
                                    {notification.status === 'failed' && (
                                      <Box>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: '#757575' }}
                                        >
                                          Error
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          sx={{ color: 'red' }}
                                        >
                                          {notification.message}
                                        </Typography>
                                      </Box>
                                    )}
                                  </>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        )}
                    </React.Fragment>
                  ))
                )}
              </div>
              {/* <div
                className="align_btw"
                style={{ padding: '8px 16px', borderTop: '1px solid #eee' }}
              >
                <div />
                <Button
                  className="clr_all"
                  onClick={(e) => {
                    e.stopPropagation() // Fixed: Prevent propagation
                    clearNotifications()
                  }}
                  sx={{
                    color: '#f44336',
                    '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.08)' },
                  }}
                >
                  Clear All
                </Button>
              </div> */}
              <div
                className="align_btw"
                style={{ padding: '8px 16px', borderTop: '1px solid #eee' }}
              >
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleNotificationView}
                  sx={{
                    color: '#1976d2',
                    borderColor: '#1976d2',
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.08)',
                      borderColor: '#1976d2',
                    },
                  }}
                >
                  View All
                </Button>
                <Button
                  className="clr_all"
                  onClick={(e) => {
                    e.stopPropagation()
                    clearNotifications()
                  }}
                  sx={{
                    color: '#f44336',
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.08)' },
                  }}
                >
                  Clear All
                </Button>
              </div>
            </div>
          </Menu>
        )}
        {children}

        {/* Mobile signout via logo removed. Use Settings > Signout tab on mobile. */}

        {isMobile && <MobileBottomNav />}

        {/* Fixed: Export Completion Notification Popup - smaller and positioned above */}
        <Fade in={exportPopupOpen}>
          <Paper
            elevation={6}
            sx={{
              position: 'fixed',
              top: 80, // Changed from bottom to top positioning
              right: 24,
              width: 320, // Reduced width
              borderRadius: 2,
              overflow: 'hidden',
              borderLeft:
                exportPopupJob?.severity === 'error'
                  ? '4px solid #f44336'
                  : '4px solid #4caf50',
              zIndex: 9999,
              animation: 'fadeIn 0.3s ease-in-out',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)', // Enhanced shadow for better visibility
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', p: 1.5 }}>
              {' '}
              {/* Reduced padding */}
              <Box sx={{ mr: 1.5, mt: 0.5 }}>
                {' '}
                {/* Reduced margin */}
                {exportPopupJob?.severity === 'error' ? (
                  <WarningIcon sx={{ color: '#f44336', fontSize: 24 }} /> // Smaller icon
                ) : (
                  <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 24 }} /> // Smaller icon
                )}
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 0.5,
                  }}
                >
                  {' '}
                  {/* Reduced margin */}
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                    {' '}
                    {/* Smaller text */}
                    {exportPopupJob?.title || 'Export Notification'}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={handleExportPopupClose}
                    sx={{ p: 0.5 }}
                  >
                    {' '}
                    {/* Smaller button */}
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Typography variant="body2" sx={{ mb: 1, fontSize: '0.8rem' }}>
                  {' '}
                  {/* Smaller text */}
                  {exportPopupJob?.message}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: '#757575', fontSize: '0.7rem' }}
                  >
                    {' '}
                    {/* Smaller text */}
                    {formatDate(new Date())}
                  </Typography>
                  {exportPopupJob?.severity === 'success' &&
                    exportPopupJob?.downloadUrl && (
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<DownloadIcon fontSize="small" />} // Smaller icon
                        onClick={handleDownload}
                        sx={{
                          backgroundColor: '#4caf50',
                          '&:hover': {
                            backgroundColor: '#3d8b40',
                          },
                          fontSize: '0.7rem', // Smaller text
                          py: 0.5, // Reduced padding
                          px: 1,
                        }}
                      >
                        Download
                      </Button>
                    )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                height: 3, // Thinner line
                backgroundColor:
                  exportPopupJob?.severity === 'error' ? '#f44336' : '#4caf50',
                width: '100%',
              }}
            />
          </Paper>
        </Fade>
      </Box>
    </Box>
  )
}

export default MainLayout
